var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 88,
    id: "filter0_d_403_3935",
    width: 88,
    x: -4.81,
    y: -6
  }, /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_403_3935"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_403_3935)",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFA692",
    height: 10.34,
    id: "svg_2",
    rx: 1.27,
    width: 10.34,
    x: 14.35,
    y: 12.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.17,
    cy: 18.02,
    fill: "#8BA293",
    id: "svg_3",
    r: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.49,0.53c0.34,-0.5 1.08,-0.5 1.41,0l5.45,7.95c0.4,0.58 -0.02,1.35 -0.71,1.35l-10.91,0c-0.69,0 -1.1,-0.78 -0.71,-1.35l5.45,-7.95z",
    fill: "#EFF4F1",
    id: "svg_4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicaciones);
export default __webpack_public_path__ + "static/media/publicaciones.4b321fa23661bf3c025b2bca68fffc01.svg";
export { ForwardRef as ReactComponent };